const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/vanessa-martin-tech",
    icon: "linkedin.svg",
    iconClassName: "h-10 w-10",
  },
  {
    label: "GitHub",
    href: "https://github.com/Atlas-Quest",
    icon: "github.svg",
    iconClassName: "h-9 w-9",
  },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-neutral-200 dark:border-neutral-800">
      <div className="container flex flex-col gap-6 px-6 py-8 tablet:flex-row tablet:items-center tablet:justify-between">
        <div className="order-2 text-center tablet:order-1 tablet:text-left">
          <p className="text-sm text-neutral-500 dark:text-neutral-500">
            &copy; {year} Vanessa Martin. All rights reserved.
          </p>
        </div>

        <div className="order-1 flex items-center justify-center gap-4 tablet:order-2 tablet:justify-end">
          {socialLinks.map(({ label, href, icon, iconClassName }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="opacity-80 transition-opacity duration-200 hover:opacity-100"
            >
              <img className={iconClassName} src={icon} alt="" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
